import {
  IconCellData,
  SortDirection,
  TableRowContent,
  TextCellData,
} from "frno-react";

export default function sort(
  sortableData: TableRowContent[],
  orderBy: Record<string, SortDirection>,
) {
  const columnsToSort = Object.keys(orderBy).filter(
    (key) => orderBy[key] != SortDirection.NONE,
  );

  if (columnsToSort.length > 0) {
    sortableData.sort((rowA, rowB) => {
      for (const column of columnsToSort) {
        const cellA = rowA.rowContent.find(
          (content) => content.columnKey === column,
        );
        const cellB = rowB.rowContent.find(
          (content) => content.columnKey === column,
        );

        if (cellA && cellB) {
          const valueA = getCellValue(cellA.cellData);
          const valueB = getCellValue(cellB.cellData);

          if (valueA != valueB) {
            return compareValues(valueA, valueB, orderBy[column]);
          }
        }
      }
      return 0;
    });
  }

  return sortableData;
}

function getCellValue(
  cellData: IconCellData | TextCellData | TextCellData[],
): string | number | boolean {
  if (Array.isArray(cellData)) {
    return cellData[0].value as string | number | boolean;
  } else {
    return cellData.value as string | number | boolean;
  }
}
function compareValues(
  valueA: string | number | boolean,
  valueB: string | number | boolean,
  sortDirection: SortDirection,
): number {
  if (typeof valueA === "number" && typeof valueB === "number") {
    return sortDirection === SortDirection.ASCENDING
      ? valueA - valueB
      : valueB - valueA;
  } else if (typeof valueA === "string" && typeof valueB === "string") {
    return sortDirection === SortDirection.ASCENDING
      ? valueA.localeCompare(valueB)
      : valueB.localeCompare(valueA);
  } else if (typeof valueA === "boolean" && typeof valueB === "boolean") {
    return sortDirection === SortDirection.ASCENDING
      ? valueA < valueB
        ? 1
        : -1
      : valueA > valueB
      ? 1
      : -1;
  } else if (typeof valueA === "number" && typeof valueB === "string") {
    return -1;
  } else if (typeof valueA === "string" && typeof valueB === "number") {
    return 1;
  } else {
    return 0;
  }
}
